<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <el-button v-if="hasPermsExport" @click="jumpExport">按条件导出数据</el-button>
    </el-button-group>

    <el-table :data="withdrawals" resource="withdrawals" v-loading="loading">
<!--      <el-table-column prop="id" label="ID" width="100" />-->
      <el-table-column prop="drawal_id" label="编码" width="250">
        <template slot-scope="scope">
          <span>订单号：{{ scope.row.drawal_id }}</span><br />
          <span>批次号：{{ scope.row.batch_no }}</span><br />

          <el-tag v-if="scope.row.status == 0" type="info">{{ scope.row.statusText }}</el-tag>
          <el-tag v-if="scope.row.status == 1">{{ scope.row.statusText }}</el-tag>
          <el-tag v-if="scope.row.status == 2" type="success">{{ scope.row.statusText }}</el-tag>
          <el-tag v-if="scope.row.status == 3" type="warning">{{ scope.row.statusText }}</el-tag>
          <el-tag v-if="scope.row.status == 4" type="info">{{ scope.row.statusText }}</el-tag>
          <el-tag v-if="scope.row.status == 5" type="danger">{{ scope.row.statusText }}</el-tag>
          <el-tag v-if="scope.row.status == 6" type="warning">{{ scope.row.statusText }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="left" header-align="center" label="账户" width="210">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}</span><br />
            <span>{{ scope.row.user.level_info.level_name }}</span><br />
            <span>{{ scope.row.user.mobile }}</span><br />
            <span>奖金：{{ scope.row.user.total_rebate?scope.row.user.total_rebate:0 }}</span><br />
            <span>锁定：{{ scope.row.user.locked_rebate?scope.row.user.locked_rebate:0 }}</span><br />
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="channelTypeText" label="提现方式" width="170" />

      <el-table-column align="left" header-align="center" label="提现金额" width="210">
        <template slot-scope="scope">
          <span>提现：{{ scope.row.total_money }}</span><br />
          <span>打款：{{ scope.row.final_money }}</span><br />
          <span>手续费：{{ scope.row.fee_money }}</span><br />
          <div v-if="scope.row.status==6">
            <span>成功提现：{{ scope.row.success_total_money }}</span><br />
            <span>成功打款：{{ scope.row.success_final_money }}</span><br />
            <span>成功手续费：{{ scope.row.success_fee_money }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column align="center" header-align="center" label="状态" width="120">
        <template slot-scope="scope" />
      </el-table-column> -->

      <el-table-column prop="created_at" label="申请时间" width="170"/>

      <el-table-column align="center" header-align="center" label="收款信息">
        <template slot-scope="scope">
          <span>{{ scope.row.rec_account }}</span>
          <br />
          <span>{{ scope.row.rec_bank_name }}</span
          ><span>{{ scope.row.rec_bank_branch }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="memo" label="用户留言"/>

      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-popconfirm
            confirm-button-text="确定"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确定执行此操作？"
            @confirm="agree(scope.row)"
            v-if="scope.row.status === 0 && hasPermsCheck"
          >
            <el-button style="margin-top: 5px" slot="reference" size="small" type="primary">同意</el-button>
          </el-popconfirm>
          <br />
          <el-button-group>
            <el-button style="margin-top: 5px" v-if="scope.row.status === 0 && hasPermsCheck" @click="disagree(scope.row)" size="small" type="danger">
              拒绝
            </el-button>
            <el-button style="margin-top: 5px" v-if="scope.row.status === 1 && hasPermsWithdrawal" @click="withdrawal(scope.row)" size="small" type="primary">
              打款
            </el-button>
            <br />
            <!--<el-button v-if="scope.row.status === 2 && hasPermsFailed" @click="withdrawalFailed(scope.row)" size="small" type="danger">打款失败</el-button>-->
            <el-button style="margin-top: 5px" v-if="hasPermsLogList" @click="operateLog(scope.row)" size="small">操作日志</el-button>
            <br />
            <el-button style="margin-top: 5px" v-if="hasPermsLogList && scope.row.batch_no" @click="withdrawalLog(scope.row)" size="small">打款日志</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
      <br />
      <el-row type="flex" justify="left" style="color: #ed5565 !important; font-size:13px;">
        当前筛选条件下，总提现金额：￥{{ totalInfo.total_money }}，总手续费：￥{{ totalInfo.fee_money }}，打款总金额:
        {{ totalInfo.final_money }}
      </el-row>
    </div>

    <el-dialog title="操作日志" :visible.sync="dialogOperateLogVisible" append-to-body v-loading="loading">
      <el-table :data="operateLogs" v-loading="loading">
        <el-table-column property="op_name" label="操作人" width="150" />
        <el-table-column property="op_type_text" label="操作类型" />
        <el-table-column property="created_at" label="操作时间" />
        <el-table-column property="log_text" label="备注" />
      </el-table>
      <div>
        <el-pagination
          @current-change="withdrawalLogsPageChange"
          :current-page.sync="withdrawalLogsPage.current_page"
          :page-size="withdrawalLogsPage.per_page"
          layout="total, prev, pager, next,jumper"
          :total="withdrawalLogsPage.total"
        />
      </div>
    </el-dialog>

    <el-dialog title="打款日志" :visible.sync="dialogWithdrawalLogsVisible" append-to-body v-loading="withdrawalLoading">
      <el-table :data="withdrawalLogs" v-loading="withdrawalLoading">
        <el-table-column
          type="index"
          label="ID"
          width="50">
        </el-table-column>
        <el-table-column property="batch_no" label="批次号"/>
        <el-table-column property="no" label="订单号" />
        <el-table-column property="fee_rate" label="手续费率(%)" />
        <el-table-column property="fee_money" label="手续费" />
        <el-table-column property="final_money" label="打款金额" />
        <el-table-column property="total_money" label="提现金额" />

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="info">{{ scope.row.status_text }}</el-tag>
            <el-tag v-if="scope.row.status == 1" type="success">{{ scope.row.status_text }}</el-tag>
            <el-tag v-if="scope.row.status == 2" type="danger">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="拒绝理由" :visible.sync="rejectDialogVisible" width="500px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="form"
        :submit="onRejectSubmit"
        :errors.sync="errors"
        :form.sync="form"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="拒绝理由" prop="reject_reason" required>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" show-word-limit maxlength="100" v-model="form.reject_reason" />
        </el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getWithdrawals, agree, disagree, withdrawalLogsList, apiWithdrawalDetailLogsList, withdrawal, withdrawalFailed, exportWithdrawals } from '@/api/withdrawals'
import LzForm from '@c/LzForm'
import { getFirstError, can } from '@/libs/utils'
import { Loading } from 'element-ui'
import { downFile } from '@/libs/download-helper'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    LzForm,
  },
  data() {
    return {
      search: [
        {
          field: 'drawal_id',
          label: '编码',
        },
        {
          field: 'batch_no',
          label: '批次号',
        },
        {
          field: 'status',
          label: '状态',
          type: 'el-select',
          options: [
            {
              id: 0,
              name: '提现申请中',
            },
            {
              id: 1,
              name: '等待打款',
            },
            {
              id: 2,
              name: '成功',
            },
            {
              id: 3,
              name: '拒绝提现',
            },
            {
              id: 4,
              name: '取消申请',
            },
            {
              id: 5,
              name: '打款失败',
            },
            {
              id: 6,
              name: '部分成功',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        // {
        //   field: 'channel_type',
        //   label: '体现方式',
        //   type: 'el-select',
        //   options: [
        //     {
        //       id: 2,
        //       name: '微信',
        //     },
        //     {
        //       id: 1,
        //       name: '支付宝',
        //     },
        //     {
        //       id: 0,
        //       name: '银行卡',
        //     },
        //   ],
        //   labelField: 'name', // 默认为 name
        //   valueField: 'id', // 默认为 id
        // },
        {
          field: 'keyword',
          label: '手机号/姓名',
        },
        {
          field: 'idcard_no',
          label: '身份证',
        },
        {
          field: 'auth_code_no',
          label: '授权码',
        },
        {
          field: 'created_at',
          label: '创建时间',
          type: 'el-date-picker'
        }
      ],
      withdrawals: [],
      dialogOperateLogVisible: false,
      operateLogs: [],
      withdrawalLogsPage: {},
      withdrawalLogsQueryData: {},
      page: null,
      loading: true,
      rejectDialogVisible: false,
      dialogWithdrawalLogsVisible: false,
      withdrawalLogs: [],
      withdrawalLoading: false,
      form: {
        id: 0,
        status: 3,
        drawal_id: 0,
        reject_reason: '',
      },
      errors: {},
      query: {},
      hasPermsCheck: false,
      hasPermsExport: false,
      hasPermsLogList: false,
      hasPermsFailed: false,
      hasPermsWithdrawal: false,
      totalInfo: {
        total_money: '',
        final_money: '',
        fee_money: '',
      },
    }
  },
  created() {
    this.hasPermsCheck = can('withdrawals.check')
    this.hasPermsExport = can('withdrawals.export')
    this.hasPermsLogList = can('withdrawalLog.list')
    this.hasPermsFailed = can('withdrawals.withdrawal-failed')
    this.hasPermsWithdrawal = can('withdrawals.withdrawal')
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData(newVal.query)
      },
      immediate: true,
    },
  },
  methods: {
    async loadData(newVal) {
      this.loading = true
      const {
        data: { data, meta, total_list },
      } = await getWithdrawals(newVal)
      this.withdrawals = data
      this.page = meta
      this.loading = false
      this.totalInfo = total_list
    },
    async agree(row) {
      try {
        const { data } = await agree(row.id, { status: 1 })
        this.$message.success(data)
        await this.loadData(this.query)
      } catch (e) {
        await this.loadData(this.query)
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    async withdrawalLogsList() {
      this.loading = true
      const {
        data: { data, meta },
      } = await withdrawalLogsList(this.withdrawalLogsQueryData)
      this.operateLogs = data
      this.withdrawalLogsPage = meta
      this.loading = false
    },
    withdrawalLogsPageChange(val) {
      this.withdrawalLogsQueryData.page = val
      this.withdrawalLogsList()
    },
    operateLog(row) {
      this.dialogOperateLogVisible = true
      this.withdrawalLogsQueryData.drawal_id = row.drawal_id
      this.withdrawalLogsList()
    },
    async withdrawalLog(row) {
      this.dialogWithdrawalLogsVisible = true
      this.withdrawalLogsQueryData.drawal_id = row.drawal_id
      this.withdrawalLoading = true
      const {
        data: { data, meta },
      } =  await apiWithdrawalDetailLogsList({'batch_no': row.batch_no})
      this.withdrawalLogs = data
      this.withdrawalLoading = false
    },
    async disagree(row) {
      this.rejectDialogVisible = true
      this.form.id = row.id
      this.form.drawal_id = row.drawal_id
    },
    async onRejectSubmit() {
      try {
        const { data } = await disagree(this.form.id, this.form)
        this.rejectDialogVisible = false
        await this.loadData(this.query)
        this.$message.success(data)
        this.clearForm()
      } catch (e) {
        console.log(e)
        await this.loadData(this.query)
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    clearForm() {
      this.form = {
        id: 0,
        drawal_id: 0,
        status: 3,
        reject_reason: '',
      }
    },
    async withdrawal(row) {
      try {
        this.loading = true;
        const { data } = await withdrawal(row.id)
        console.log('withdrawal', data);
        this.$message.success(data)
        await this.loadData(this.query)
        this.loading = false
      } catch (e) {
        this.loading = false
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
        await this.loadData(this.query)
      }
    },
    async withdrawalFailed(row) {
      try {
        const { data } = await withdrawalFailed(row.id)
        this.$message.success(data)
        await this.loadData(this.query)
      } catch (e) {
        await this.loadData(this.query)
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    async jumpExport() {
      const loadingInstance = Loading.service({ target: document.querySelector('.loading-area'), text: '下载中...' })
      const { data } = await exportWithdrawals(this.query).setConfig({ responseType: 'blob' })
      let blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      downFile(blob, 'withdrawals.xlsx')
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close()
      })
    },
  },
}
</script>
